<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 flex justify-between">
            <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Dashboard') }}</h1>
            <template v-if="$store.state.permissions && $store.state.permissions['App.Http.Controllers.Api.Dashboard.StatsController']">
                <input-range-date :onDateRangeChange="handleDateRangeChange" />
            </template>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <template v-if="$store.state.permissions && $store.state.permissions['App.Http.Controllers.Api.Dashboard.StatsController']">
                <div class="py-4">
                    <stats ref="statsComponent"/>
                </div>
                <div class="py-4 flex">
                    <tickets-by-types ref="ticketsByTypesComponent"/>
                    <opened-tickets ref="openedTicketsComponent"/>
                </div>
            </template>
        </div>
    </main>
</template>

<script>
import Stats from "@/components/widgets/stats";
import OpenedTickets from "@/components/widgets/opened-tickets";
import TicketsByTypes from "@/components/widgets/tickets-by-types";
import InputRangeDate from "@/components/forms/input-range-date";

export default {
    name: "home",
    metaInfo() {
        return {
            title: this.$i18n.t('Dashboard')
        }
    },
    components: {OpenedTickets, TicketsByTypes, Stats, InputRangeDate},
    methods: {
        handleDateRangeChange(dates) {
            if(dates.startDate && dates.endDate) {
                if (this.$refs.statsComponent) {
                    this.$refs.statsComponent.getData(dates);
                }
                if (this.$refs.ticketsByTypesComponent) {
                    this.$refs.ticketsByTypesComponent.getData(dates);
                }
                if (this.$refs.openedTicketsComponent) {
                    this.$refs.openedTicketsComponent.getData(dates);
                }
            }
        }
    },
}
</script>
